import React, { useEffect, useState } from 'react';
import TauriHostSection from './TauriHostSection/TauriHostSection';
import './TauriHostContainer.css';

const TauriHostContainer = ({ itemSection, chartPalette, chartTheme }) => {
  const [isXL, setIsXL] = useState(window.innerWidth <= 1200);
  const [isLG, setIsLG] = useState(window.innerWidth <= 992);

  useEffect(() => {
    const handleResize = () => {
      setIsXL(window.innerWidth <= 1200);
      setIsLG(window.innerWidth <= 992);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div className='tauri-host-container p-2 p-xl-3'>
      {itemSection.map((section, index) => (
        <div
          key={index}
          style={{
            gridColumn: `span ${itemSection.length === 1 ? 12 : isLG ? 12 : isXL ? 6 : section.columns}`, 
            gridRow: `span ${section.rows}`,
          }}
        >
          <TauriHostSection section={section} palettes={chartPalette} themes={chartTheme} />
        </div>
      ))}
    </div>
  );
};

export default TauriHostContainer;
